export function formatText(text: string, tag: string = 'span') {
  return text ? text.replace(/({{(.*?)}})/g, (a, b, t) => tag ? `<${tag}>${t}</${tag}>` : t) : text
}

export function stripHTMLTags(content: string) {
  if (content) {
    const sentence = []
    const regSentence = content.split(/<\/?[^>]+(>|$)/g)
    for (const part of regSentence) {
      if (part !== '' && part !== '>') sentence.push(part)
    }
    return sentence.join(' ')
  }

  return ''
}

export function cleanWagtailRichText(html: string) {
  return html ? html.replace(/data-block-key="[^\"]*"/g, '') : html
}

export const useComputedModel = (props: any, emit: any, prop: string = 'modelValue') => computed({
  get() {
    return props[prop]
  },

  set(value) {
    emit(`update:${prop}`, value)
  }
})

export function usePascalCase(name: string) {
  try {
    return name
      .split('_')
      .map(i => i[0].toUpperCase() + i.slice(1, i.length))
      .join('')
  } catch (e) {
    return ''
  }
}

export const useFlickity = (options: FlickityOptions) => {
  const flickity: Ref<Flickity | null> = shallowRef(null);
  const index: Ref<number> = ref(0)

  function handleFlickityReady(_flickity: Flickity){
    flickity.value = _flickity
    _flickity.on('change', (e) => {
      index.value = e
    })
  }

  function next(){
    flickity.value?.next()
  }

  function previous(){
    flickity.value?.previous()
  }

  function selectSlide(index: number){
    flickity.value?.select(index)
  }

  return {
    flickity,
    options,
    index,

    handleFlickityReady,
    next,
    previous,
    selectSlide
  }
}

export function createUniqueID(length) {
  let result = ''
  let counter = 0
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  const charactersLength = characters.length
  while (counter < length) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength))
    counter += 1
  }
  return result
}

export function useCamelCase(name: string) {
  try {
    return name.split('_').map((item, index) => (index === 0 ? item.charAt(0).toLowerCase() : item.charAt(0).toUpperCase()) + item.slice(1).toLowerCase()).join('');
  } catch(e) {
    return '';
  }
}

export function formatPrice(price: any, currency: string = 'EUR', lang: string, withoutDecimals: boolean = false) {
  if (isNaN(price)) return '';
  // every price is in cents
  price = price / 100;
  return new Intl.NumberFormat(lang || 'hr-HR', { 
    style: 'currency',
    currency,
    minimumFractionDigits: withoutDecimals ? 0 : 2,
    maximumFractionDigits: withoutDecimals ? 0 : 2
  }).format(price);
}

export function isValidDate(value: any) {
  if (typeof value !== 'string') return false;
  const date = new Date(value);
  return !isNaN(date.getTime());
}

export function formatStayTextId(id: string) {
  return !id ? '' : id.charAt(0).toLowerCase() + id.slice(1);
}

export function getThemeStyles(accommodation: object) {
  if (accommodation?.brand?.theme_class) {
    const brandClass = useCamelCase(accommodation.brand.theme_class);
    document.documentElement.style.setProperty('--themeColor', `var(--${brandClass})`);
    document.documentElement.style.setProperty('--themeColorDarken', `var(--${brandClass}Darken)`);
  }
}

export function removeThemeStyles() {
  document.documentElement.style.setProperty('--themeColor', `var(--defaultThemeColor`);
  document.documentElement.style.setProperty('--themeColorDarken', `var(--defaultThemeColorDarken)`);
}

export const handleApiErrorsRedirects = async (error: object, redirectUrl: string) => {
  let type = error?.data?.error_class || '';
  if (type) {
    if (type === 'validation') {
      if (error.data?.details?.accommodation?.[0]?.code === 'does_not_exist') {
        return await navigateTo({ path: redirectUrl, query: { error: 'invalid_id' } });
      }
    } else if (type === 'action' && error.data?.details?.code && ['booking_new_unit_not_available', 'invalid_promo_code'].includes(error.data.details.code)) {
      return error.data?.details?.code;
    }
  }
  if (redirectUrl) return await navigateTo(redirectUrl);
}

export function togglePasswordVisibility(event, repeat = false, customClass = '') {
  let element = document.querySelector(repeat ? '.form__PasswordRepeatField input' : `${ customClass || '.form__PasswordFirstField'} input`);
  if (element) element.type = element.type === 'password' ? 'text' : 'password';
}

export function convertHexToRgba(hex, alpha) {
  let r = 0, g = 0, b = 0;
  if (hex.length === 4) {
    r = parseInt(hex[1] + hex[1], 16);
    g = parseInt(hex[2] + hex[2], 16);
    b = parseInt(hex[3] + hex[3], 16);
  } else if (hex.length === 7) {
    r = parseInt(hex[1] + hex[2], 16);
    g = parseInt(hex[3] + hex[4], 16);
    b = parseInt(hex[5] + hex[6], 16);
  }
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}
